import { Spinner } from "@blueprintjs/core";
import * as React from "react";
import { useParams } from "react-router";

import {
  EPlatform,
  ERequestState,
  RequestDto,
  WorkAttestationRequestApi,
  WorkAttestationRequestDto,
} from "../../../../api";
import { PageContainer } from "../../../../components";
import { useApiService, useCrudApi, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { DrupalRequestResume } from "../../../common";
import { DrupalFieldSet } from "../../../common/DurpalFieldSet";
import { EDrupalRoutes } from "../../../EDrupalRoutes";
import { DrupalWorkAttestRequestForm } from "./DrupalWorkAttestRequestForm";

export interface IDrupalWorkAttestRequestPageProps {}

export const DrupalWorkAttestRequestPage: React.FunctionComponent<IDrupalWorkAttestRequestPageProps> = () => {
  const { id } = useParams<{ id: string }>();

  const workAttestationRequestId = React.useMemo(() => +id, [id]);

  const { t } = useTl();
  const api = useApiService(WorkAttestationRequestApi);

  // TODO-CRR : saving is used, but not saveItem???
  const { data, loading, saving } = useCrudApi<WorkAttestationRequestDto>(
    React.useMemo(
      () => ({
        getApiFn: (apiId = workAttestationRequestId) =>
          apiId > 0
            ? api.getWorkAttestationRequest(apiId)
            : new WorkAttestationRequestDto({
                request: new RequestDto({
                  requestDate: new Date(),
                  status: ERequestState.REQUESTED,
                  platform: EPlatform.PORTAL,
                }),
              }).toJSON(),
        saveApiFn: (d: WorkAttestationRequestDto) =>
          api.saveWorkAttestationRequest(WorkAttestationRequestDto.fromJS({ ...d, isPortal: true })),
        onSavedRoute: (d) =>
          d.request.status === ERequestState.BILLED
            ? `${EDrupalRoutes.workAttestRequest}/${d.workAttestationRequestId}`
            : EDrupalRoutes.requestList,
        deleteApiFn: () => {},
      }),
      [api, workAttestationRequestId]
    ),
    [workAttestationRequestId]
  );

  return loading ? (
    <Spinner />
  ) : (
    <PageContainer>
      <DrupalFieldSet title={`${t(ETLCodes.Payment)}: ${t(ETLCodes.WorkAttestationRequest)}`}>
        <div>
          {saving ? (
            <Spinner />
          ) : (
            <DrupalRequestResume
              requestForm={
                <DrupalWorkAttestRequestForm
                  workAttestRequestId={workAttestationRequestId}
                  initialdata={data}
                  loading={saving}
                />
              }
              requestDto={data?.request}
              bill={null}
            />
          )}
        </div>
      </DrupalFieldSet>
    </PageContainer>
  );
};
